import React, { useState } from 'react';
import { LayoutDashboard, Users, Building, FileText, Upload, Plus, Edit, Trash2 } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { MessageModal } from '../../components/modals/MessageModal';
import { ConfirmModal } from '../../components/modals/ConfirmModal';
import { AddPlotModal } from '../../components/modals/AddPlotModal';
import { EditPlotModal } from '../../components/modals/EditPlotModal';
export function InventoryPage() {
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isAddPlotModalOpen, setIsAddPlotModalOpen] = useState(false);
  const [isEditPlotModalOpen, setIsEditPlotModalOpen] = useState(false);
  const [selectedPlot, setSelectedPlot] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [projectFilter, setProjectFilter] = useState('All Projects');
  const [statusFilter, setStatusFilter] = useState('Status: All');
  const navItems = [{
    label: 'Overview',
    icon: LayoutDashboard,
    path: '/dashboard/developer'
  }, {
    label: 'Inventory',
    icon: Building,
    path: '/developer/inventory'
  }, {
    label: 'Leads & CRM',
    icon: Users,
    path: '/developer/leads'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/developer/reports'
  }];
  const plots = [{
    proj: 'Green Valley',
    no: 'A-101',
    size: '2,400',
    price: '45',
    status: 'Available',
    date: 'Today',
    facing: 'North'
  }, {
    proj: 'Green Valley',
    no: 'A-102',
    size: '2,400',
    price: '45',
    status: 'Booked',
    date: 'Yesterday',
    facing: 'East'
  }, {
    proj: 'Sunrise Hts',
    no: 'B-205',
    size: '1,800',
    price: '38',
    status: 'Available',
    date: 'Oct 20',
    facing: 'South'
  }, {
    proj: 'Sunrise Hts',
    no: 'C-301',
    size: '3,000',
    price: '52',
    status: 'Sold',
    date: 'Oct 15',
    facing: 'West'
  }, {
    proj: 'Green Valley',
    no: 'C-302',
    size: '3,000',
    price: '52',
    status: 'Available',
    date: 'Oct 12',
    facing: 'North-East'
  }];
  const filteredPlots = plots.filter(plot => {
    const matchesSearch = searchQuery === '' || plot.no.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesProject = projectFilter === 'All Projects' || plot.proj.includes(projectFilter.split(' ')[0]);
    const matchesStatus = statusFilter === 'Status: All' || plot.status === statusFilter;
    return matchesSearch && matchesProject && matchesStatus;
  });
  const handleImportCSV = () => {
    setIsMessageModalOpen(true);
  };
  const handleAddPlot = () => {
    setIsAddPlotModalOpen(true);
  };
  const handleEdit = (plot: any) => {
    setSelectedPlot({
      plotNumber: plot.no,
      size: plot.size,
      facing: plot.facing,
      price: plot.price,
      status: plot.status,
      project: plot.proj
    });
    setIsEditPlotModalOpen(true);
  };
  const handleDeleteClick = (plotNo: string) => {
    setSelectedPlot({
      plotNumber: plotNo
    });
    setIsConfirmModalOpen(true);
  };
  const handleConfirmDelete = () => {
    setIsConfirmModalOpen(false);
    setIsMessageModalOpen(true);
  };
  return <DashboardLayout title="Developer Console" personaLabel="DEVELOPER" personaColor="bg-blue-100 text-blue-800 border-blue-200" navItems={navItems} userInitials="DL" data-id="element-3806">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-3807">
        <div data-id="element-3808">
          <h1 className="text-2xl font-bold mb-1" data-id="element-3809">Master Inventory</h1>
          <p className="text-gray-500 font-mono text-sm" data-id="element-3810">
            Manage plots across all active projects.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-3811">
          <button onClick={handleImportCSV} className="flex items-center gap-2 px-4 py-2 border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50" data-id="element-3812">
            <Upload className="w-4 h-4" data-id="element-3813" /> Import CSV
          </button>
          <button onClick={handleAddPlot} className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-3814">
            <Plus className="w-4 h-4" data-id="element-3815" /> Add Plot
          </button>
        </div>
      </div>

      <div className="bg-white border border-gray-300 mb-8" data-id="element-3816">
        <div className="p-4 border-b border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4 bg-gray-50" data-id="element-3817">
          <div className="flex gap-2 w-full md:w-auto" data-id="element-3818">
            <select value={projectFilter} onChange={e => setProjectFilter(e.target.value)} className="bg-white border border-gray-300 text-sm p-2 rounded-sm focus:outline-none focus:border-gray-500" data-id="element-3819">
              <option data-id="element-3820">All Projects</option>
              <option data-id="element-3821">Green Valley Phase 1</option>
              <option data-id="element-3822">Sunrise Heights</option>
            </select>
            <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="bg-white border border-gray-300 text-sm p-2 rounded-sm focus:outline-none focus:border-gray-500" data-id="element-3823">
              <option data-id="element-3824">Status: All</option>
              <option data-id="element-3825">Available</option>
              <option data-id="element-3826">Booked</option>
              <option data-id="element-3827">Sold</option>
            </select>
          </div>
          <div className="relative w-full md:w-64" data-id="element-3828">
            <input type="text" placeholder="Search plot no..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-3 pr-4 py-2 border border-gray-300 text-sm focus:outline-none focus:border-gray-500" data-id="element-3829" />
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-3830">
          <table className="w-full text-left text-sm min-w-[800px]" data-id="element-3831">
            <thead className="bg-gray-50 border-b border-gray-200 font-mono text-xs uppercase text-gray-500" data-id="element-3832">
              <tr data-id="element-3833">
                <th className="p-4 font-bold" data-id="element-3834">Project</th>
                <th className="p-4 font-bold" data-id="element-3835">Plot No.</th>
                <th className="p-4 font-bold" data-id="element-3836">Size (Sq.Ft)</th>
                <th className="p-4 font-bold" data-id="element-3837">Price</th>
                <th className="p-4 font-bold" data-id="element-3838">Status</th>
                <th className="p-4 font-bold" data-id="element-3839">Last Updated</th>
                <th className="p-4 font-bold text-right" data-id="element-3840">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-3841">
              {filteredPlots.map((plot, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-3842">
                  <td className="p-4 font-bold text-gray-600" data-id="element-3843">{plot.proj}</td>
                  <td className="p-4 font-bold" data-id="element-3844">{plot.no}</td>
                  <td className="p-4 font-mono" data-id="element-3845">{plot.size}</td>
                  <td className="p-4 font-bold" data-id="element-3846">₹{plot.price}L</td>
                  <td className="p-4" data-id="element-3847">
                    <span className={`inline-block px-2 py-0.5 text-xs font-bold rounded-sm border ${plot.status === 'Available' ? 'bg-green-100 text-green-800 border-green-200' : plot.status === 'Booked' ? 'bg-yellow-100 text-yellow-800 border-yellow-200' : 'bg-gray-100 text-gray-600 border-gray-200'}`} data-id="element-3848">
                      {plot.status.toUpperCase()}
                    </span>
                  </td>
                  <td className="p-4 text-xs text-gray-500" data-id="element-3849">{plot.date}</td>
                  <td className="p-4 text-right" data-id="element-3850">
                    <div className="flex justify-end gap-2" data-id="element-3851">
                      <button onClick={() => handleEdit(plot)} className="p-1.5 hover:bg-gray-200 rounded" title="Edit Plot" data-id="element-3852">
                        <Edit className="w-4 h-4 text-gray-600" data-id="element-3853" />
                      </button>
                      <button onClick={() => handleDeleteClick(plot.no)} className="p-1.5 hover:bg-red-100 rounded" title="Delete Plot" data-id="element-3854">
                        <Trash2 className="w-4 h-4 text-red-600" data-id="element-3855" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {filteredPlots.length === 0 && <div className="p-12 text-center text-gray-500" data-id="element-3856">
            <p className="font-mono text-sm" data-id="element-3857">
              No plots found matching your criteria
            </p>
          </div>}
      </div>

      <AddPlotModal isOpen={isAddPlotModalOpen} onClose={() => setIsAddPlotModalOpen(false)} projectName="Green Valley Phase 1" data-id="element-3858" />

      {selectedPlot && selectedPlot.project && <EditPlotModal isOpen={isEditPlotModalOpen} onClose={() => setIsEditPlotModalOpen(false)} plot={selectedPlot} data-id="element-3859" />}

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title={selectedPlot?.plotNumber ? `Plot Deleted` : 'Import CSV'} message={selectedPlot?.plotNumber ? `Plot ${selectedPlot.plotNumber} has been deleted successfully.` : 'CSV import feature allows bulk upload of plots. Upload an Excel/CSV file with columns: Plot No, Size, Price, Status, Facing.'} type={selectedPlot?.plotNumber ? 'success' : 'info'} data-id="element-3860" />

      <ConfirmModal isOpen={isConfirmModalOpen} onClose={() => setIsConfirmModalOpen(false)} onConfirm={handleConfirmDelete} title="Delete Plot" message={`Are you sure you want to delete plot ${selectedPlot?.plotNumber}? This action cannot be undone.`} confirmText="Delete" type="danger" data-id="element-3861" />
    </DashboardLayout>;
}